import { AWS_S3_DOCUMENT_BUCKET } from '../config';

// https://s3.amazonaws.com/<bucket>/<key>, https://s3.<region>.amazonaws.com/<bucket>/<key>
const PATH_STYLE_URL = /^https?:\/\/s3(?:[.-][a-z0-9-]+)?\.amazonaws\.com\/([^/]+)\/(.+)$/i;
// https://<bucket>.s3.amazonaws.com/<key>, https://<bucket>.s3.<region>.amazonaws.com/<key>
const VIRTUAL_HOST_URL = /^https?:\/\/([^/]+?)\.s3(?:[.-][a-z0-9-]+)?\.amazonaws\.com\/(.+)$/i;

const safeDecode = (value) => {
  try {
    return decodeURIComponent(value);
  } catch (error) {
    return value;
  }
};

/**
 * Resolves a stored document reference to { bucket, key }.
 *
 * Kids Cafe enrichment documents used to be stored as public S3 URLs; they are
 * now stored as the bare object key. Both forms are accepted so applications
 * saved before the change keep working. Returns null for an empty value or a
 * URL that does not point at S3.
 */
const parseS3ObjectRef = (value, defaultBucket = AWS_S3_DOCUMENT_BUCKET) => {
  if (typeof value !== 'string' || !value.trim()) {
    return null;
  }

  const reference = value.trim();
  const match = reference.match(PATH_STYLE_URL) || reference.match(VIRTUAL_HOST_URL);

  if (match) {
    return { bucket: match[1], key: safeDecode(match[2]) };
  }

  if (/^https?:\/\//i.test(reference)) {
    return null;
  }

  return { bucket: defaultBucket, key: reference };
};

export default parseS3ObjectRef;
